const menacemystereData = [
  {
    lang: "fr",
    titre: "Menace Mystère",
    intro: "Un filet de pêche a été troué… Mais qui a fait cela ?",
    consigne: [
      `<class="bold">Clique</class> sur les photos pour les remettre\ndans l’ordre et <class="bold">identifier</class> le coupable. `,
      `<class="bold">Observe</class> bien les indices et\n<class="bold">clique</class> sur la réponse pour retrouver le coupable. `,
    ],
    consigne2: "Utilise les flèches pour te déplacer\ndans le décor.",
    letters: ["A", "C", "E", "R", "B"],
    reponse: ["C", "R", "A", "B", "E"],
    buttonLabel1: "Suivant",
    buttonLabel2: "Valider",
    buttonLabel3: "Entrer cette réponse",
    bonneReponseImage: "bonne-rep-activite-1",
    mauvaiseReponseImage: "mauvaise-rep-activite-1",
    bouteilleVideImage: "bouteille-vide-activite-4",
    bouteilleFinaleImage: "bouteille-finale-4",
    info: `Quelqu’un a saboté le filet de pêche !\nRetrouve le <class='boldBlue'>morceau manquant</class> : tu y\ndécouvriras un <class='boldBlue'>oeuf de poisson\nrescapé</class>... Il pourrait bien te mener\njusqu’au coupable.`,
    info2: `L’individu a dévoré les oeufs... sauf un ! Observe ses <class='boldBlue'>motifs </class>et retrouve sa maman parmi <class='boldBlue'>les trois poissons</class>. Elle a vu le fuyard et te montrera par où il s’est échappé.`,
    info3: `Le coupable s’est enfui dans la <class='boldBlue'>posidonie</class> ! Il saccage tout sur son passage ! Suis le bon chemin du <class='boldBlue'>labyrinthe</class> pour découvrir l’identité de cette mystérieuse menace...`,
    filetsPositions: [
      { x: 150, y: 180 },
      { x: 400, y: 280 },
      { x: 170, y: 400 },
      { x: 1200, y: 200 },
      { x: 1400, y: 300 },
      { x: 1100, y: 420 },
    ],
    endTitre: "Bravo !",
    endTexte: `Tu as retrouvé le coupable, c'est le :`,
    endTexte2: `C’est ce petit crabe bleu, une espèce invasive, qui a causé tant de dégâts.`,
    fishData: [
      { x: 140, index: 1 },
      { x: 280, index: 2 },
      { x: 420, index: 3 },
    ],
    clickable: [
      { x: -430, y: -624, index: 0, illu: "poulpe" },
      { x: 60, y: -590, index: 1, illu: "requin" },
      { x: 560, y: -590, index: 2, illu: "crabe" },
    ],
    videoKey: "chaineAlimentaireVideo",
  },
  {
    lang: "en",
    titre: "MYSTERY THREAT",
    intro: "A fishing net is ripped!",
    consigne: [
      `<class="bold">Tap</class> the pictures in the right order to find out. `,
      `<class="bold">Look</class> carefully at the clues and click the answer to find who did it.. `,
    ],
    consigne2: "Use the arrows to move through the scene.",
    letters: ["A", "C", "S", "R", "B"],
    reponse: ["C", "R", "A", "B", "S"],
    buttonLabel1: "Next",
    buttonLabel2: "Validate",
    buttonLabel3: "Enter this answer",
    bonneReponseImage: "bonne-rep-activite-1-en",
    mauvaiseReponseImage: "mauvaise-rep-activite-1-en",
    bouteilleVideImage: "bouteille-vide-activite-4-en",
    bouteilleFinaleImage: "bouteille-finale-4-en",
    info: `Someone sabotaged the fishing net!\nFind the <class='boldBlue'>missing piece</class> — you’ll spo\na surviving <class='boldBlue'>fish egg</class>... It might jus\nlead you to the one who did it.`,
    info2: `The sneaky one ate all the eggs…\nexcept one ! Look at its <class='boldBlue'>patterns</class> and\nfind its mom among <class='boldBlue'>the three fishes</class>.\nShe saw what escaped and will\nshow you which way it went.`,
    info3: `The troublemaker ran off into the\n<class='boldBlue'>seagrass</class>! It’s wrecking everything\nalong the way! Follow the right path\nthrough the <class='boldBlue'>maze</class> to discover this\nmysterious threat...`,
    filetsPositions: [
      { x: 150, y: 180 },
      { x: 400, y: 280 },
      { x: 170, y: 400 },
      { x: 1200, y: 200 },
      { x: 1400, y: 300 },
      { x: 1100, y: 420 },
    ],
    endTitre: "Well done !",
    endTexte: `You found who did it — it’s the:`,
    endTexte2: `This little blue crab is an invader and causes lots of trouble.`,
    fishData: [
      { x: 140, index: 1 },
      { x: 280, index: 2 },
      { x: 420, index: 3 },
    ],
    clickable: [
      { x: -430, y: -624, index: 0, illu: "poulpe" },
      { x: 60, y: -590, index: 1, illu: "requin" },
      { x: 560, y: -590, index: 2, illu: "crabe" },
    ],
    videoKey: "chaineAlimentaireVideo-en",
  },
];

export default menacemystereData;
